var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgGoogle(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 23,
    height: 22,
    viewBox: "0 0 23 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M5.37566 13.2951L4.60987 16.1539L1.81093 16.2131C0.974461 14.6616 0.5 12.8865 0.5 11.0002C0.5 9.17614 0.943609 7.45601 1.72994 5.94141H1.73054L4.22238 6.39825L5.31396 8.87514C5.0855 9.5412 4.96097 10.2562 4.96097 11.0002C4.96106 11.8077 5.10732 12.5813 5.37566 13.2951Z",
    fill: "#FBBB00"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.3082 8.94482C22.4345 9.61024 22.5004 10.2974 22.5004 10.9998C22.5004 11.7873 22.4176 12.5555 22.2598 13.2965C21.7243 15.818 20.3252 18.0198 18.3869 19.578L18.3863 19.5774L15.2477 19.4172L14.8035 16.6442C16.0896 15.89 17.0947 14.7096 17.6242 13.2965H11.7422V8.94482H17.71H22.3082Z",
    fill: "#518EF8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.3855 19.5776L18.3861 19.5782C16.501 21.0934 14.1064 22 11.4996 22C7.31055 22 3.66847 19.6586 1.81055 16.2129L5.37528 13.2949C6.30422 15.7741 8.69582 17.539 11.4996 17.539C12.7048 17.539 13.8338 17.2132 14.8026 16.6445L18.3855 19.5776Z",
    fill: "#28B446"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.5218 2.53241L14.9583 5.44981C13.9556 4.82307 12.7703 4.46102 11.5005 4.46102C8.63327 4.46102 6.19694 6.30682 5.31453 8.87494L1.73107 5.9412H1.73047C3.56119 2.41154 7.2492 0 11.5005 0C14.1695 0 16.6167 0.950726 18.5218 2.53241Z",
    fill: "#F14336"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 22,
    height: 22,
    fill: "white",
    transform: "translate(0.5)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGoogle);
export default __webpack_public_path__ + "static/media/Google.226b3ad67f046e5dd3e3260b72521945.svg";
export { ForwardRef as ReactComponent };